import { render, staticRenderFns } from "./UsersCallRecordingModal.vue?vue&type=template&id=dbfb5dd2&"
import script from "./UsersCallRecordingModal.vue?vue&type=script&lang=js&"
export * from "./UsersCallRecordingModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports